export const loadMessagesPage = () => import('../pages/MessagesPage');

export function preloadMessagesPage() {
  void loadMessagesPage().catch(() => undefined);
}
